/**
 * Renders a `Payment.status` from `/payment/payments/` as a label and colour.
 *
 * The backend's STATUS_CHOICES are `pending`, `succeeded`, `failed` and
 * `refunded` - four states, not two. Treating everything that is not
 * `succeeded` as a failure paints a pending transfer and a refund red, which
 * is wrong in opposite directions. Note also that `Payment.status` defaults to
 * `'PENDING'` in upper case, which is not one of its own choices, so rows
 * created without an explicit status arrive miscased; compare lowercased.
 *
 * An unrecognised status is shown as-is rather than forced into one of the
 * four, so a new backend state is visible instead of silently mislabelled.
 */
export interface PaymentStatusDisplay {
  label: string
  className: string
}

const NEUTRAL = 'text-lightGray'

export const formatPaymentStatus = (
  t: (key: string) => string,
  status?: string | null,
): PaymentStatusDisplay => {
  switch (status?.trim().toLowerCase()) {
    case 'succeeded':
      return { label: t('PAID'), className: 'text-[#21BA45]' }
    case 'pending':
      return { label: t('PENDING'), className: 'text-inProgressText' }
    case 'refunded':
      return { label: t('REFUNDED'), className: NEUTRAL }
    case 'failed':
      return { label: t('FAILED'), className: 'text-deleteRed' }
    default:
      return { label: status || '-', className: NEUTRAL }
  }
}
